import { render, staticRenderFns } from "./quotationShare.vue?vue&type=template&id=218bbff9&scoped=true"
import script from "./quotationShare.vue?vue&type=script&lang=js"
export * from "./quotationShare.vue?vue&type=script&lang=js"
import style0 from "./quotationShare.vue?vue&type=style&index=0&id=218bbff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218bbff9",
  null
  
)

export default component.exports